<template>
  <div class="w-full flex flex-col">
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="flex flex-row items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
          <g clip-path="url(#clip0_1736_51300)">
            <path
              d="M1.75033 15.3422V9.45155H0V8.18742H4.78911V9.45155H3.01446V15.3422H1.75033ZM1.75033 6.06319V1.82568H3.01446V6.06319H1.75033ZM5.6176 6.06319V4.79906H7.36794V1.82568H8.63207V4.79906H10.3824V6.06319H5.6176ZM7.36794 15.3422V8.18742H8.63207V15.3422H7.36794ZM12.9855 15.3422V12.3688H11.2109V11.1046H16V12.3688H14.2497V15.3422H12.9855ZM12.9855 8.98042V1.82568H14.2497V8.98042H12.9855Z"
              fill="#4F4F4F" />
          </g>
          <defs>
            <clipPath id="clip0_1736_51300">
              <rect width="16" height="16" fill="white" transform="translate(0 0.583984)" />
            </clipPath>
          </defs>
        </svg>
        <h4 class="nxp-review-title">Detalhes Profissionais</h4>
      </div>

      <button class="nxp-review-title-action" type="button"
        @click="$router.push({ name: 'edit-professional-details' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
            fill="#4F4F4F" />
        </svg>
        Editar
      </button>
    </div>
    <hr class="custom-hr my-2" />

    <div v-if="show()" class="nxp-review-data flex flex-col px-6">
      <p v-if="professional_profile.available">
        <b>Disponível para novas oportunidades: </b> {{ professional_profile.available ? "Sim" : "Não" }}
      </p>

      <p v-if="professional_profile.remote">
        <b>Disponível para trabalho remoto: </b> {{ professional_profile.remote ? "Sim" : "Não" }}
      </p>

      <p v-if="professional_profile.realocation">
        <b>Disponível para viajar a trabalho: </b> {{ professional_profile.realocation ? "Sim" : "Não" }}
      </p>

      <p v-if="professional_profile.regimes">
        <b>Regime de Contratação:</b> {{ professional_profile.regimes }}
      </p>

      <p v-if="professional_profile.intended_remuneration">
        <b>Pretensão Salárial:</b> {{ professional_profile.intended_remuneration }}
      </p>

      <p v-if="showTalent() && talent.facebook_url">
        <b>Facebook:</b> {{ talent.facebook_url }}
      </p>

      <p v-if="showTalent() && talent.linkedin_url">
        <b>LinkedIn:</b> {{ talent.linkedin_url }}
      </p>

      <p v-if="showTalent() && talent.website_url">
        <b>Website:</b> {{ talent.website_url }}
      </p>

      <p v-if="showTalent() && talent.github_url">
        <b>Github</b>: {{ talent.github_url }}
      </p>
    </div>

    <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
      <p class="nxp-review-no-data-text">
        Você ainda não preencheu seus detalhes profissionais.
      </p>
      <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'edit-professional-details' })">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
            fill="#4F4F4F" />
        </svg>
        Adicionar seus detalhes profissionais
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard';

export default {
  computed: {
    ...mapState('professional_profile', ['professional_profile']),
    ...mapState('talent', ['talent']),

    icon_avaliable() {
      return this.professional_profile.available == 'Sim' ||
        this.professional_profile.available == true ||
        this.professional_profile.available == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_remote() {
      return this.professional_profile.remote == 'Sim' ||
        this.professional_profile.remote == true ||
        this.professional_profile.remote == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_relocation() {
      return this.professional_profile.relocation == 'Sim' ||
        this.professional_profile.relocation == true ||
        this.professional_profile.relocation == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_avaliable_color() {
      return this.professional_profile.available == 'Sim' ||
        this.professional_profile.available == true ||
        this.professional_profile.available == 'Yes' ? 'text-success' : 'text-danger'
    },

    icon_remote_color() {
      return this.professional_profile.remote == 'Sim' ||
        this.professional_profile.remote == true ||
        this.professional_profile.remote == 'Yes' ? 'text-success' : 'text-danger'
    },

    icon_relocation_color() {
      return this.professional_profile.relocation == 'Sim' ||
        this.professional_profile.relocation == true ||
        this.professional_profile.relocation == 'Yes' ? 'text-success' : 'text-danger'
    },


  },
  methods: {
    showTalent() {
      return Object.keys(this.talent).length > 0
    },

    show() {
      return Object.keys(this.professional_profile)
        .filter(key => this.professional_profile[key] != null).length > 5
    }
  },

  components: {
    EmptyDetailCard
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/professionalprofilecard.scss';

hr {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
}
</style>